export const SET_USER_ALL_LOCATION_DATA = 'SET_USER_ALL_LOCATION_DATA';
export const DELETE_USER_LOCATION = 'DELETE_USER_LOCATION';
export const SET_THIRD_PARTY_LOCATIONS = 'SET_THIRD_PARTY_LOCATIONS';
export const SET_SINGLE_LOCATION_DETAIL = 'SET_SINGLE_LOCATION_DETAIL';
